import { ReactNode, createContext } from "react";
import useInstituicao, { InstituicaoType, CreateInstituicaoType, EditInstituicaoType } from "./hooks/useInstituicao";

interface InstituicaoContextProviderProps {
    children: ReactNode;
}

export interface InstituicaoContextData {
    createInstituicao: (createInstituicaoData: CreateInstituicaoType) => Promise<CreateInstituicaoType | null>;
    getInstituicaoPaged: (
        pageNumber: number,
        Name?: string,
        EmpresaId?: number,
        pageSize?: number
    ) => Promise<InstituicaoType[] | null>;
    updateInstituicao: (editInstituicaoData: EditInstituicaoType) => Promise<EditInstituicaoType | null>;
    deleteInstituicao: (instituicaoId: number) => Promise<InstituicaoType | null>;
    handleGetInstituicaoByUserId: (userId: number) => Promise<InstituicaoType | null>;
    handleGetInstituicaoById: (instituicaoId: number) => Promise<InstituicaoType | null>;
    setInstituicao: any;
    instituicao: InstituicaoType;
    listInstituicao: InstituicaoType[];
    initialListInstituicao: InstituicaoType[];
    setListInstituicao: (instituicoes: InstituicaoType[]) => void;
    setPageCount: (count: number) => void;
    pageCount: number;
    handleGetInstituicaoByEmpresaId: (empresaId: number) => Promise<InstituicaoType[] | null>;
}

const initialState: InstituicaoContextData = {
    createInstituicao: async () => null,
    getInstituicaoPaged: async () => null,
    updateInstituicao: async () => null,
    deleteInstituicao: async () => null,
    handleGetInstituicaoByUserId: async () => null,
    handleGetInstituicaoById: async () => null,
    setInstituicao: () => { },
    instituicao: {
        id: 0,
        name: "",
        email: "",
        cep: "",
        state: "",
        city: "",
        neighborhood: "",
        address: "",
        number: 0,
        directorPhone: "",
        isPrivate: false,
        pix: "",
        // userId: 0,
        empresaId: 0,
    },
    listInstituicao: [],
    initialListInstituicao: [],
    setListInstituicao: () => { },
    setPageCount: () => { },
    pageCount: 0,
    handleGetInstituicaoByEmpresaId: async () => null,
};

export const InstituicaoContext =
    createContext<InstituicaoContextData>(initialState);

export default function InstituicaoContextProvider({
    children,
}: InstituicaoContextProviderProps) {
    const {
        createInstituicao,
        getInstituicaoPaged,
        updateInstituicao,
        deleteInstituicao,
        handleGetInstituicaoByUserId,
        handleGetInstituicaoById,
        setInstituicao,
        instituicao,
        listInstituicao,
        initialListInstituicao,
        setListInstituicao,
        pageCount,
        setPageCount,
        handleGetInstituicaoByEmpresaId,
    } = useInstituicao();

    return (
        <InstituicaoContext.Provider
            value={{
                createInstituicao,
                getInstituicaoPaged,
                updateInstituicao,
                deleteInstituicao,
                handleGetInstituicaoByUserId,
                handleGetInstituicaoById,
                setInstituicao,
                instituicao,
                listInstituicao,
                initialListInstituicao,
                setListInstituicao,
                setPageCount,
                pageCount,
                handleGetInstituicaoByEmpresaId,
            }}
        >
            {children}
        </InstituicaoContext.Provider>
    );
}
